import { Observable, of } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { DEEP_LINK_TOKEN, DeepLinkProvider, Log } from '@core';

export class AppsFlyerDeepLinkingStep extends StartupStep {
  private readonly deepLinkProvider: DeepLinkProvider = inject(DEEP_LINK_TOKEN);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'AppsFlyerDeepLinkingStep START' });

    this.deepLinkProvider.initializeDeepLinking();

    this.logger.log(Log.Startup, { message: 'AppsFlyerDeepLinkingStep COMPLETED' });

    return of(state);
  }
}
